// src/state/slices/productSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchProducts } from "../../graphql/api/productService";
import { Product } from "../../interfaces/home_entity";

// Thunk to load products
export const loadProducts = createAsyncThunk("products/load", async () => {
  const data = await fetchProducts(); // should return Product[]
  return data;
});

// Define the product slice state type
interface ProductState {
  items: Product[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: ProductState = {
  items: [],
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "product", // use singular to match access as state.product
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadProducts.fulfilled, (state, action: PayloadAction<Product[]>) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(loadProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Error loading products";
      });
  },
});

export default productSlice.reducer;
